import PatientDetailsHeader from "../../pages/StudyList/components/Headers/PatientDetailsHeader";
import ReportDetailsHeader from "../../pages/StudyList/components/Headers/ReportDetailsHeader";
import StudyDetailsHeader from "../../pages/StudyList/components/Headers/StudyDetailsHeader";
import ActionsHeader from "../../pages/StudyList/components/Headers/ActionsHeader";
import TriageHeader from "../../pages/StudyList/components/Headers/TriageHeader";
import PatientDetails from "../../pages/StudyList/components/PatientDetails";
import RadiologistDetails from "../../pages/StudyList/components/RadiologistDetails";
import ReportDetails from "../../pages/StudyList/components/ReportDetails";
import StudyDetails from "../../pages/StudyList/components/StudyDetails";
import StudyProps from "../../pages/StudyList/components/StudyProps";
import TriageDetails from "../../pages/StudyList/components/TriageDetails";
import ActionDetails from "../../pages/StudyList/components/ActionDetails";
import StudyListHeader from "../../pages/StudyList/components/Headers/StudyListHeader";

export const StudyListColumns = (table) => [
  [
    // {
    //   id: "select",
    //   header: ({ table }) => (
    //     <IndeterminateCheckbox
    //       {...{
    //         header: true,
    //         checked: table.getIsAllRowsSelected(),
    //         indeterminate: table.getIsSomeRowsSelected(),
    //         onChange: table.getToggleAllRowsSelectedHandler(),
    //       }}
    //     />
    //   ),
    //   cell: ({ row }) => (
    //     <div className="px-1">
    //       <IndeterminateCheckbox
    //         {...{
    //           row,
    //           header: false,
    //           checked: row.getIsSelected(),
    //           disabled: !row.getCanSelect(),
    //           indeterminate: row.getIsSomeSelected(),
    //           onChange: row.getToggleSelectedHandler(),
    //         }}
    //       />
    //     </div>
    //   ),
    // },
    // {
    //   id: "patientDetails",
    //   accessorFn: (row) => row.id,
    //   accessorKey: "patientDetails",
    //   cell: (info) => <PatientDetails data={info} />,
    //   header: () => <span>Patient Details</span>,
    //   footer: (props) => props.column.id,
    // },
    // {
    //   id: "studies",
    //   header: () => <span>Study Details</span>,
    //   accessor: "studies",
    //   accessorKey: "username",
    //   cell: (info) => <StudyDetails data={info} />,
    // },
    // {
    //   id: "triage",
    //   header: () => <span>Triage</span>,
    //   accessor: "triage",
    //   accessorKey: "triage",
    //   cell: (info) => <TriageDetails data={info} />,
    // },
    // {
    //   id: "radiologist",
    //   header: () => <span>Radiologist</span>,
    //   accessor: "radiologist",
    //   accessorKey: "radiologist",
    //   cell: (info) => (
    //     <RadiologistDetails
    //       data={info.radiologistList == undefined ? [] : info.radiologistList}
    //     />
    //   ),
    // },
    // {
    //   id: "reportDetails",
    //   header: () => <span>Report Details</span>,
    //   accessor: "reportDetails",
    //   accessorKey: "reportDetails",
    //   cell: (info) => <ReportDetails data={info} />,
    // },
    // {
    //   id: "actions",
    //   header: () => <span>Actions</span>,
    //   accessor: "actions",
    //   accessorKey: "actions",
    //   cell: (info) => <ActionDetails data={info} />,
    // },
  ]
]